import { useState } from "react"
import { useWindowSize } from "../../../../../core/hooks/common/useWindowSize"
import { useAclContext } from "../../../../../core/contexts/acl"
import { TABLET_SIZE } from "../../../../../core/constants/common"
import SwapListingTable from "../../../reports/swap/SwapListingTable"
import RSwapListingTable from "../../../../responsive/main/reports/swap/RSwapListingTable"
import ListLayout from "../../../../layout/main/ListLayout"
import { PageCard } from "../../../../../styles/CommonStyles"
import FilterLayout from "../../../../layout/filter/FilterLayout"
import { useGetAllSwaps } from "../../../../../core/services/react-query/report/swap"
import { CacheKeys } from "../../../../../core/constants/filter"
import { UserDetailListWrapper } from "../../../../../styles/main/user"



const UserSwapListing = ({ user }) => {

    const { width } = useWindowSize()
    const [swaps, setSwaps] = useState({ data: null, loading: true })

    const { permissions } = useAclContext()
    const hasDownload = permissions?.export?.write

    const onQuerySuccess = (res) => {
        setSwaps(res)
    }

    const Component = width > TABLET_SIZE ? SwapListingTable : RSwapListingTable

    return (
        <UserDetailListWrapper>
            <FilterLayout
                query={useGetAllSwaps}
                onQuerySuccess={onQuerySuccess}
                options={useGetAllSwaps}
                cache={CacheKeys.SWAPS}
                hasDownload={hasDownload}
                extra={{ 'client.userId': user?._id }}
            >
                {width &&
                    <Component
                        data={swaps}
                    />
                }
            </FilterLayout>
        </UserDetailListWrapper>

    )
}

export default UserSwapListing;
